
<div class="orderByNavbar"  *ngIf="shouldWeHideThisComponent()"
     [ngClass]="{ blurElement : shouldWeBlurThisComponentFN() }" >
  <h3 class="orderByNavbar__label headerLabel"> Chart of : </h3>

  <div class="orderByNavbar__optionsWrapper">
    <span class="orderByNavbar__option containerOfDropdownArrow">
        {{ currentSelectedOption.description | shortenText }}
          <svg class="dropdownArrow">  <use xlink:href="/assets/symbol-defs.svg#icon-select-arrows"></use> </svg>
      </span>

    <ul class="orderByNavbar__optionsList optionListStyle" >
      <li class=" optionStyle" *ngFor="let option of orderByOptions"
          [ngClass]="{'optionStyle-selected' : currentSelectedOption.id === option.id}"
          [id]="[option.id]" (click)="onClickOption($event)"> {{ option.description }} </li>
    </ul>
  </div>
</div>






